import React from "react";

export default function EditUserPopUp({ closeToast, onBackToManageUsers }) {
  const handleClose = () => {
    closeToast(); // Close the toast when "OK" is clicked
    // Call the callback function to navigate
    if (onBackToManageUsers) {
        onBackToManageUsers();
    }
  };

  return (
    <div>
      <div className="">
        <div id="">
          <div id="">
            <p className="popUpText">
                User Information has been updated.
            </p>
            <button className="alert_button" onClick={handleClose}>
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
